export enum TourStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  CANCELLED = 'CANCELLED',
  ARCHIVED = 'ARCHIVED',
}
